import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getExperienceBasicInfo } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { getOnsiteUpsellComponents } from "@src/store/slices/experienceComponents";
import { mpOnsiteUpsellEdited } from "@src/utils/mixpanel";
import { getOnsiteUpsellMpProperties } from "@src/utils/mpUtils";

// Fired when the builder opens onto an existing upsell — i.e. the user is
// editing, not creating. Returns early when no upsell exists yet (the creation
// path), so it only tags real edits. A test exposes every group's upsell at
// once, so emit one event per existing component (each with its own id).
export const trackOnsiteUpsellEdited = createAsyncThunk<void, void>(
  "experienceBuilder/tracking/onsiteUpsellEdited",
  (_, { getState }) => {
    const state = getState();
    const components = getOnsiteUpsellComponents()(state);
    if (components.length === 0) {
      return;
    }

    const experienceInfo = getExperienceBasicInfo(state);
    if (!experienceInfo) {
      return;
    }

    components.forEach((component) => {
      const { componentId, surface } = getOnsiteUpsellMpProperties(component);

      mpOnsiteUpsellEdited({
        componentId,
        surface,
        experienceType: experienceInfo.experienceType,
        experienceId: experienceInfo.experienceId,
      });
    });
  }
);
